import LanguageDisplay from './LanguageDisplay';
import LanguageDiscussionModal from './LanguageDiscussionModal';
import LanguageDropdown from './LanguageDropdown';

export const components = {
  LanguageDisplay,
  LanguageDiscussionModal,
  LanguageDropdown,
};
